import React from 'react';
import { SEO } from '../components/SEO';

export const TermsConditions = () => {
  return (
    <div className="min-h-screen pt-32 pb-20">
      <SEO 
        title="Terms & Conditions | Calspark Electrical & Engineers"
        description="Terms and Conditions for using Calspark Electrical & Engineers website and services."
        ogUrl="/terms-and-conditions"
      />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-800 to-slate-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms & Conditions</h1>
          <p className="text-lg text-slate-300">Calspark Electrical & Engineers</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-slate-500 mb-8 text-base">Last updated: June 2025</p>
            
            <p className="text-slate-700 text-lg leading-relaxed mb-8">
              By accessing and using calsparkengineers.com, you accept and agree to be bound by the following terms and conditions.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Use of Website</h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              The content of this website is for general information and use only. It is subject to change without notice. Unauthorised use of this website may give rise to a claim for damages and/or be a criminal offence.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Intellectual Property</h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              All content on this website including text, graphics, logos, and images is the property of Calspark Electrical & Engineers and is protected by applicable intellectual property laws.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Disclaimer</h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              The information on this website is provided "as is" without any representations or warranties. Calspark Electrical & Engineers makes no representations or warranties in relation to the information on this website.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Project Enquiries</h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              Submitting an enquiry through our website does not constitute a contract or guarantee of services. All projects are subject to formal agreement.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Governing Law</h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              These terms and conditions are governed by and construed in accordance with the laws of India and any disputes shall be subject to the exclusive jurisdiction of the courts of Bangalore, Karnataka.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Contact Us</h2>
            <p className="text-slate-700 text-lg leading-relaxed">
              For any queries regarding these terms, please contact us at{' '}
              <a href="mailto:enquiry@calsparkengineers.com" className="text-teal-600 hover:text-teal-700 font-medium">
                enquiry@calsparkengineers.com
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
